<template>
  <template v-if="checkedType.includes(item.type)">
    <component
      :is="`ll-${item.type}`"
      ref="componentRef"
      v-model:checked="formData[item.key]"
      v-bind="getBindValue(item)"
      @change="handleChange"
      @blur="handleBlur"
    />
  </template>
  <template v-else>
    <component
      :is="`ll-${item.type}`"
      ref="componentRef"
      v-model:value="formData[item.key]"
      v-bind="getBindValue(item)"
      @change="handleChange"
      @blur="handleBlur"
    />
  </template>
</template>

<script setup lang="ts">
import { has, omit } from 'lodash-es'
import { nextTick, reactive, ref } from 'vue'
import {
  checkedType,
  formComponentEmits,
  formComponentProps,
  type FormColumn,
} from '../config'

const props = defineProps(formComponentProps)

const emits = defineEmits(formComponentEmits)

const formData = reactive(props.formData)

const componentRef = ref()

const getBindValue = (item: FormColumn) => {
  const obj = { ...item }
  return omit(obj, ['label', 'onChange', 'change', 'blur', 'onBlur', 'class'])
}

const handleChange = (...arg) => {
  const item: FormColumn = props.item
  if (has(item, 'change')) {
    item.change(...arg)
  }
  if (has(item, 'onChange')) {
    item.onChange(...arg)
  }
  emits('changeField', item)
}
const handleBlur = (...arg) => {
  const item: FormColumn = props.item
  if (has(item, 'blur')) {
    item.blur(...arg)
  }
  if (has(item, 'onBlur')) {
    item.onBlur(...arg)
  }
  emits('blurField', item)
}
// 获取焦点
const focus = async () => {
  await nextTick()
  componentRef.value?.focus()
}

const getItem = () => {
  return props.item
}
defineExpose({
  focus,
  getItem,
})
</script>
